import React, { useEffect, useState } from 'react'
import Negocio from '../../functions/logic/Negocio'
import Spiner from '../../components/Spiner'
import { useSnackbar } from 'notistack'

export default function OrdersForm({ formData = {} }) {
    const [file, setFile] = useState(null)
    const [comprobanteUrl, setComprobanteUrl] = useState(formData.checkoutPago?.archivo_adjunto || '')
    const baseUrl = global.IMGProd
    const [spiner, setSpiner] = useState(false)
    const { enqueueSnackbar } = useSnackbar()
    const [fechaPago, setFechaPago] = useState('')

    useEffect(() => {
        if (formData?.checkoutPago?.fecha_pago) {
            const split = formData.checkoutPago.fecha_pago.split(" ")
            setFechaPago(split[0])
        } else {
            setFechaPago("")
        }
    }, [formData])

    const handleFileChange = async (event) => {
        setSpiner(true)
        if (!fechaPago) {
            enqueueSnackbar('Selecciona una fecha de pago', {
                variant: 'warning',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
        } else {
            const selectedFile = event.target.files[0]
            if (!selectedFile) return

            setFile(selectedFile)

            const userToken = localStorage.getItem("userToken")
            const param = JSON.parse(localStorage.getItem('param'));

            try {
                const response = await Negocio.saveComprobantePagoLogic(userToken, param, formData.id, selectedFile, fechaPago)
                enqueueSnackbar(response.data.message, {
                    variant: response.data.variant,
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    }
                })
                if (!response.error) {
                    setComprobanteUrl(response.data.data.url)
                }
            } catch (error) {
                enqueueSnackbar('Hubo un error al enviar el comprobante de pago.', {
                    variant: 'danger',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    }
                })
            }
        }
        setSpiner(false)
    }


    const renderPaymentSection = () => {
        const { checkoutPago } = formData || {}

        if (checkoutPago && checkoutPago.nemonico_pago === 'METPA0004') {
            return (
                <div className="card mt-3">
                    <div className="card-header">
                        <h5>Método de Pago</h5>
                    </div>
                    <div className="card-body">
                        {comprobanteUrl ? (
                            <>
                                <div className="row">
                                    {/* Sección para subir el comprobante */}
                                    <div className="col-md-6">
                                        <label>Comprobante(Transferencia)</label>
                                        <input type="file" accept="image/*" className="form-control" onChange={handleFileChange} />
                                    </div>



                                    {/* Sección para la fecha */}
                                    <div className="col-md-6">
                                        <label htmlFor="fechaNacimiento">Fecha de pago</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="fechaNacimiento"
                                            name="fechaNacimiento"
                                            value={fechaPago}
                                            onChange={e => {
                                                setFechaPago(e.target.value);
                                                localStorage.setItem('fechaNaci', e.target.value);
                                            }}
                                            required
                                        />
                                    </div>

                                    {/* Sección para mostrar la imagen y botón de descarga */}
                                    <div className="col-md-6 text-center mt-3">
                                        <p><strong>Comprobante de pago:</strong></p>
                                        <a href={baseUrl + comprobanteUrl} target="_blank" rel="noopener noreferrer">
                                            <img src={baseUrl + comprobanteUrl} alt="Comprobante de pago" className="img-fluid rounded border" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                                        </a>
                                        <br />
                                        <a target='_blank' rel="noreferrer" href={baseUrl + comprobanteUrl} download className="btn btn-primary mt-2">Descargar Comprobante</a>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Comprobante de pago (Transferencia)</label>
                                    <input type="file" accept="image/*" className="form-control" onChange={handleFileChange} />
                                </div>

                                <div className="col-md-6">
                                    <label htmlFor="fechaNacimiento">Fecha de pago</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="fechaNacimiento"
                                        name="fechaNacimiento"
                                        value={fechaPago}
                                        onChange={e => {
                                            setFechaPago(e.target.value);
                                            localStorage.setItem('fechaPago', e.target.value);
                                        }}
                                        required
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                </div>
            )
        } else if (checkoutPago && checkoutPago.nemonico_pago === 'METPA0001') {
            return (
                <div className="card mt-3">
                    <div className="card-header">
                        <h5>Método de Pago</h5>
                    </div>
                    <div className="card-body">
                        <div className="col-md-6">

                            <p><strong>Efectivo</strong></p>
                            <label htmlFor="fechaNacimiento">Fecha de pago</label>
                            <input
                                type="date"
                                className="form-control"
                                id="fechaNacimiento"
                                name="fechaNacimiento"
                                value={fechaPago}
                                onChange={e => {
                                    setFechaPago(e.target.value);
                                    localStorage.setItem('fechaPago', e.target.value);
                                }}
                                required
                            />
                        </div>
                    </div>
                </div>
            )
        }
    }
    return (
        <div className="container mt-4">
            <Spiner opt={spiner} />
            <div className="row">
                <div className="col-md-8">
                    <div className="card" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        <div className="card-header">
                            <h5>Carrito ({formData.checkoutDetail?.length || 0} productos)</h5>
                        </div>
                        <div className="card-body">
                            {formData.checkoutDetail?.map((product, index) => (
                                <div key={index} className="d-flex align-items-center mb-3">
                                    <img src={baseUrl + product.url_imagen} alt={product.nombre} className="img-thumbnail" style={{ width: '80px', height: '80px', marginRight: '15px' }} />
                                    <div className="ms-3">
                                        <h6><strong>{product.nombre}</strong></h6>
                                        <p>Cantidad: {product.cantidad}</p>
                                        {product.tiene_descuento === "t" ? (
                                            <p><del className="text-danger">${product.precio}</del> <span className="text-success">Descuento: ${product.precio_descuento}</span></p>
                                        ) : (
                                            <p className="text-dark">${product.precio}</p>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {renderPaymentSection()}
                </div>
                <div className="col-md-4">
                    <div className="card mb-3">
                        <div className="card-header">
                            <h5>Resumen de tu pedido</h5>
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between">
                                <strong>Subtotal IVA 15%:</strong> <span>${formData.subtotal_iva || '0.00'}</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <strong>Subtotal IVA 0%:</strong> <span>${formData.subtotal_sin_iva || '0.00'}</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <strong>IVA:</strong> <span>${formData.iva || '0.00'}</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <strong>Envío:</strong> <span>{formData.envio ? `$${formData.envio}` : 'No seleccionado'}</span>
                            </div>
                            <hr />
                            <div className="d-flex justify-content-between">
                                <h5><strong>Total:</strong></h5> <h5><strong>${formData.total || '0.00'}</strong></h5>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header">
                            <h5>Dirección de Envío</h5>
                        </div>
                        <div className="card-body">
                            <p><strong>Nombre</strong>{formData.checkoutAddress?.nombres + " " + formData.checkoutAddress?.apellidos || 'Nombre no disponible'}</p>
                            <p><strong>Dirección:</strong> {formData.checkoutAddress?.direccion}, {formData.checkoutAddress?.ciudad}</p>
                            <p><strong>Provincia:</strong> {formData.checkoutAddress?.provincia}, Ciudad: {formData.checkoutAddress?.ciudad}</p>
                            <p><strong>Código Postal:</strong> {formData.checkoutAddress?.codigo_postal}</p>
                            <p><strong>Teléfono:</strong> {formData.checkoutAddress?.telefono_contacto}</p>
                            <p className="text-muted">Esta es tu dirección de envío por defecto</p>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header">
                            <h5>Método de envío</h5>
                        </div>
                        <div className="card-body">
                            <div
                                className="shipping-option"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "10px",
                                    marginBottom: "10px",
                                    border: "1px solid #ddd",
                                    borderRadius: "5px",
                                    backgroundColor: "#f8f9fa",
                                }}
                            >
                                <label
                                    className="form-check-label"
                                    htmlFor={`shipping-${formData.metodoEnvioData.id}`}
                                    style={{ fontSize: "14px", fontWeight: "500" }}
                                >
                                    <strong>{formData.metodoEnvioData.nombre}</strong> - ${formData.metodoEnvioData.costo} ({parseInt(formData.metodoEnvioData.dias)} días)
                                    <br />
                                    <span style={{ fontSize: "12px", color: "#6c757d" }}>
                                        {formData.metodoEnvioData.descripcion}
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
